var activeTerms = {};

(function ($) {
    $(function () {
        const filterContainer = $('.filters');
        const filterToggle = $('.filterToggle');

        const $moreButton = filterContainer.closest('.wrap').find('.loadMore button');

        let filterAnimation = gsap
            .timeline({
                paused: true,
                defaults: {
                    ease: 'power3.inOut'
                }
            })
            .to(filterContainer, 0.5, { height: 'auto' })
            .from(filterContainer.find('.h3'), 0.3, { autoAlpha: 0, y: 20 }, "-=0.2")
            .from(filterContainer.find('ul'), 0.3, { autoAlpha: 0, y: 20 }, "-=0.2")
        ;

        filterAnimation.progress(1);
        filterAnimation.reversed(true);

        // toggle filter animation
        function toggleFilter() {
            // get text from data-text attribute
            var text = filterToggle.data('text');

            // update text and save old text in data-text attribute
            filterToggle.data('text', filterToggle.find('span').text()).find('span').text(text);

            // toggle filter animation
            filterAnimation.reversed() ? filterAnimation.timeScale(1).play() : filterAnimation.timeScale(1.2).reverse();
        }

        filterToggle.on('click', toggleFilter);

        // scrolltrigger for filter animation
        gsap.registerPlugin(ScrollTrigger);

        ScrollTrigger.create({
            trigger: filterToggle,
            start: 'top 50%',
            end: 'bottom 50%',
            toggleActions: 'play none none none',
            //markers: true,
            once: true,
            onEnter: function () {
                var text = filterToggle.data('text');
                filterToggle.data('text', filterToggle.find('span').text()).find('span').text(text);
                filterAnimation.timeScale(1.2).reverse();
            }
        });

        $('.filters').on('click', '.term:not(.disabled)', function () {
            var removeButton = $('<span class="remove"><i class="icon-close"></i></span>');

            // append close button to filter if has class active, else remove close button
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this)
                    .find('.remove')
                    .remove();
            } else {
                $(this).addClass('active');
                $(this).append(removeButton);
            }

            // get filter taxonomy and active terms
            var tax = $(this)
                .closest('.filterGroup')
                .data('tax');
            var terms = $(this)
                .closest('ul')
                .find('.active');

            // get all active terms and put them in an array
            if (terms.length) {
                activeTerms[tax] = [];

                $.each(terms, function (index, term) {
                    term_id = $(term).data('id');

                    // add term_id to activeTerms array if not already in array otherwise create new array
                    if ($.inArray(term_id, activeTerms[tax]) == -1) {
                        activeTerms[tax].push(term_id);
                    } else {
                        activeTerms[tax] = [term_id];
                    }
                });
            } else {
                delete activeTerms[tax];
            }

            // load filtered posts with ajax and set new filter state
            $.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                dataType: 'json',
                data: {
                    action: 'filter_articles',
                    type: $(this)
                        .closest('.filters')
                        .data('type'),
                    terms: activeTerms,
                    nonce: $(this)
                        .closest('.filters')
                        .data('nonce'),
                },
                success: function (res) {
                    $('.entries').html(res.posts);
                    $('.filters').html(res.filter);

                    // hide load more button if button is present and no more posts
                    if ($moreButton.length) {
                        $moreButton.data('page', 1);

                        if (res.more === false) {
                            $moreButton.hide();
                        } else {
                            $moreButton.show();
                        }
                    }
                },
            });
        });
    });
})(jQuery);
